// extracted by mini-css-extract-plugin
export default {"locale_he_IL":"styling-provider_locale_he_IL__FEbto"};